import type { PageProps } from '@/components/success-gambling/components/page/page.types';
import '@/components/success-gambling/components/page/page.css';

export default function Page(props: PageProps) {
  const { title, children } = props;

  return (
    <div className='success-gambling-page'>
      <h1 className='success-gambling-page__greeting'>{title}</h1>
      {children}
    </div>
  );
}
